import classNames from 'classnames'
import { DataModel } from 'legacy/lut/classes/models/DataModel'
import { IBusinessProfileIcon } from 'legacy/lut/classes/services/api/BusinessProfileApi'
import businessProfileStoreService from 'legacy/lut/classes/services/BusinessProfileStoreService'
import { TabButtons } from 'legacy/lut/library/tabButtons'
import { IState } from 'legacy/lut/store'
import { ILookupState } from 'legacy/lut/store/state'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import { IForm } from 'core-components/classes/models/IForm'
import { Item } from 'core-components/library/grid'
import { HttpCancel } from 'core/classes/http'
import { TUser } from 'core/classes/models/User'

import addressBlock from './contactTileBlocks/addressBlock'
import hpProfileBlock from './contactTileBlocks/hpProfileBlock'
import phoneBlock from './contactTileBlocks/phoneBlock'
import registrationBlock from './contactTileBlocks/registrationBlock'
import summaryBlock from './contactTileBlocks/summaryBlock'

import styles from './ContactTileCell.module.scss'

interface IProps {
  className?: string
  item: DataModel | IForm
  defaultTab?: number
  hideTabs?: boolean
  relationship: IBusinessProfileIcon[]
  changeMindset: IBusinessProfileIcon[]
  roles: IBusinessProfileIcon[]
  status: IBusinessProfileIcon[]
  user: TUser
}

/** TODO: Should be rewrited */
const ContactTileCell = (props: IProps) => {
  const [currentTab, setTab] = useState(`${props.defaultTab}` || '0')
  const [isLoadingReg, setLoadingReg] = useState(true)
  const [registration, setRegistration] = useState<IObjectAny>()

  const contactId = props.item.get('ContactID')

  useEffect(() => {
    if (contactId && !registration && currentTab === '3') {
      setLoadingReg(true)
      businessProfileStoreService
        .getRegDashboardReal(contactId, new HttpCancel())
        .then((result) => {
          setRegistration(result)
          setLoadingReg(false)
        })
    }
  }, [contactId, currentTab])

  return (
    <Item
      key={props.item.get('ContactID')}
      xs={12}
      md={6}
      lg={4}
      className={classNames(styles.root, props.className || '')}
    >
      <div className={styles.card}>
        <TabButtons
          value={currentTab}
          onChange={(id) => setTab(id)}
          classes={{
            root: styles.tabs,
            header: styles.tabs__header,
            button: styles.tabs__button,
            content: styles.tabs__content,
          }}
          items={[
            {
              id: '0',
              label: 'Summary',
              content: () => summaryBlock(props),
            },
            {
              id: '1',
              label: 'Address',
              content: () => addressBlock(props.item),
            },
            {
              id: '2',
              label: 'Phone',
              content: () => phoneBlock(props.item),
            },
            {
              id: '3',
              label: 'Registration',
              content: () => registrationBlock(props.item, isLoadingReg, registration),
            },
            {
              id: '4',
              label: 'HP Profile',
              content: () => hpProfileBlock(props.item),
            },
          ]}
        />
      </div>
    </Item>
  )
}

const mapStateToProps = (
  state: IState & ILookupState,
  ownProps: Pick<IProps, 'item' | 'className' | 'defaultTab' | 'hideTabs'>
): IProps => ({
  item: ownProps.item,
  hideTabs: ownProps.hideTabs,
  className: ownProps.className,
  defaultTab: ownProps.defaultTab,
  relationship: state.lookupOld.businessProfileWidget.relationship,
  changeMindset: state.lookupOld.businessProfileWidget.changeMindset,
  roles: state.lookupOld.businessProfileWidget.roles,
  status: state.lookupOld.businessProfileWidget.status,
  user: state.app.user,
})

const WidgetContactTileCellConnected = connect(mapStateToProps)(ContactTileCell)
export { WidgetContactTileCellConnected as ContactTileCell }
